import React from 'react'
import ReactMarkdown from 'react-markdown'

import { compose, join, map, pickAll } from 'ramda'
import styled from 'styled-components'

type Props = {
  strings: {}
  keys: string[]
  variables?: string[]
  variableColor?: string
}

const Container = styled.span`
  display: block;
`

const performSubstitution = (unformattedString: string, variables: string[] | null) =>
  (variables ?? []).reduce(
    (accumulator: string, variable: string, index: number) =>
      accumulator.replace(`%${index + 1}$s`, variable),
    unformattedString,
  )

const performFormatting = (displayString: string, variableColor: string) => {
  let formattedString: string
  if (variableColor) {
    formattedString = displayString
      .replace('**', `<b><font color="${variableColor}">`)
      .replace('**', '</font></b>')
      .replace('**', `<b><font color="${variableColor}">`)
      .replace('**', '</font></b>')
  } else {
    formattedString = displayString.replace('**', '<b>').replace('**', '</b>')
  }

  return formattedString
}

export const getDisplayString = ({
  strings = {},
  keys,
  variables = null,
  variableColor = null,
}: {
  strings: object
  keys: string[]
  variables?: string[]
  variableColor?: string
}) => {
  const target = pickAll([...keys], strings)
  const getDisplayValue = key => target?.[key] || ''
  const substitutedString = performSubstitution(
    compose(join(' '), map(getDisplayValue))(keys),
    variables,
  )

  return performFormatting(substitutedString, variableColor)
}

export const getMarkdownString = ({ strings, keys, variables = null }) => {
  const target = pickAll([...keys], strings)
  const getDisplayValue = key => target?.[key] || ''
  return performSubstitution(compose(join(' '), map(getDisplayValue))(keys), variables)
}

const Markdown = (props: Props) => (
  <Container>
    <ReactMarkdown source={getMarkdownString(props)} />
  </Container>
)

export { useRemoteStrings } from './useRemoteStrings'

export default Markdown
